import { render, staticRenderFns } from "./collaborators-view.vue?vue&type=template&id=84844062&scoped=true&"
import script from "./collaborators-view.vue?vue&type=script&lang=js&"
export * from "./collaborators-view.vue?vue&type=script&lang=js&"
import style0 from "./collaborators-view.vue?vue&type=style&index=0&id=84844062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84844062",
  null
  
)

export default component.exports